import { Box, Tooltip, Typography } from '@dtx-company/design-system/src'
import React from 'react'

interface PlanChipV3Props {
  planLabel: string
  showTooltipText?: boolean
}

export const PlanChipV3: React.FC<PlanChipV3Props> = ({ planLabel, showTooltipText }) => {
  const tooltipArticle = ['a', 'e', 'i', 'o', 'u'].includes(
    (planLabel?.charAt(0) ?? '').toLowerCase()
  )
    ? 'an'
    : 'a'
  const tooltipText = showTooltipText
    ? `Your account has ${tooltipArticle} ${planLabel} subscription`
    : undefined

  return (
    <Tooltip
      title={tooltipText ? <Typography variant="labelSmall">{tooltipText}</Typography> : null}
      arrow
    >
      <Box
        sx={theme => ({
          borderRadius: theme.spacing(25),
          padding: theme.spacing(0.5, 2),
          height: theme.spacing(6),
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'secondary.main',
          cursor: 'default',
          '.MuiTypography-overline': { fontWeight: 700 }
        })}
      >
        <Typography variant="overlineMedium">{planLabel.toUpperCase()}</Typography>
      </Box>
    </Tooltip>
  )
}
